import useAuthUtilities from '@/AuthMiddleware/AuthUtilities';
import { AlbumState } from '@/data/models/albumState';
import { IAlbum } from '@/data/models/album';
import { useMutation } from '@tanstack/react-query';
import { changeRequestApiClient } from '@/clients/ChangeRequestAPIClient';
import { IChangeRequest } from '@/data/models/changeRequest';

export default function useUpdateChangeRequestMutation() {
  const { canUserEditProduct } = useAuthUtilities();

  return useMutation({
    mutationFn: async ({
      albumId,
      album,
      changeRequest,
      state,
    }: {
      albumId: string;
      album: IAlbum;
      changeRequest: IChangeRequest;
      state: AlbumState;
    }) => {
      if (!canUserEditProduct(state)) {
        throw new Error(
          `User cannot update change request for state: ${state}`
        );
      }

      if (!changeRequest) {
        throw new Error('Change request is required to update change request');
      }

      return await changeRequestApiClient.updateChangeRequest(
        albumId,
        changeRequest.id!,
        { ...changeRequest, changeRequestAlbum: album }
      );
    },
  });
}
